import React, { useEffect, useRef } from 'react';

const TextAreaInput = ({
  inputValue,
  onInputChange,
  onBlur,
  label,
  id,
  autoFocus,
}) => {
  const textareaRef = useRef();

  useEffect(() => {
    if (autoFocus && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="c-letter-slide__textarea-container">
      <label htmlFor={id}>{label}</label>
      <textarea
        ref={textareaRef}
        className="c-letter-slide__textarea-input"
        id={id}
        value={inputValue}
        onBlur={onBlur}
        onChange={(e) => onInputChange(e)}
      />
    </div>
  );
};

export default TextAreaInput;
